import {ClientUserState} from '../../../shared/scripts/ClientUserState'
import {UIProfileLinkController} from '../../../shared/scripts/profile/UIProfileLinkController'
import {UIProfileSettingsController} from '../../../shared/scripts/profile/UIProfileSettingsController'
import {navigateToPage} from '../../../shared/scripts/ui_utils/ClientUtils.ts'

export class UIWProfileSettingsController extends UIProfileSettingsController {
    private readonly username: string

    private readonly profileLinkController: UIProfileLinkController

    private profileIsCurrentUser: boolean

    constructor(username: string, profileLinkController: UIProfileLinkController) {
        super()
        this.username = username
        this.profileLinkController = profileLinkController

        this.init()
    }

    private init() {
        this.profileIsCurrentUser = this.isProfileCurrentUser()

        if(!this.profileIsCurrentUser) {
            this.hideSettingsTab()
            this.redirectToMainProfileSection()
            return
        }
    }

    private isProfileCurrentUser(): boolean {
        if(ClientUserState.userState == undefined) return false
        return ClientUserState.userState.username.toLowerCase() == decodeURIComponent(this.username.toLowerCase())
    }

    hideSettingsTab() {
        if(this.profileLinkController.settingsSectionLink == undefined) return
        this.profileLinkController.settingsSectionLink.style.display = 'none'
    }

    showSettingsTab() {
        if(this.profileLinkController.settingsSectionLink == undefined) return
        this.profileLinkController.settingsSectionLink.style.display = 'flex'
    }

    private redirectToMainProfileSection() {
        if(this.profileLinkController.activeLink != this.profileLinkController.settingsSectionLink) return
        navigateToPage(`/profile/${this.username}`)
    }
}
